const actionType = (context) => {
  const exception = ['undefined', 'false', '0', '', 'null']

  return [
    {
      name: 'product_gift',
      append() {}
    },
    {
      name: 'discount_on_products',
      append(formData) {
        formData.append('discount', context._data.form.discount)
      }
    },
    {
      name: 'discount_on_section',
      append: (formData) => {
        if (exception.includes(formData.get('catalog_section_id'))) {
          formData.append("catalog_section_id", context._data.sectionsId);
        }
        
        formData.append('discount', context._data.form.discount)
      }
    },
    {
      name: 'discount_on_maker',
      append: (formData) => {
        if (exception.includes(formData.get('maker_id'))) {
          formData.append("maker_id", context._data.maker_id);
        }

        formData.append('discount', context._data.form.discount)
      }
    }
  ]
}

export default function() {
  const context = this;

  return {
    actionTypes: actionType(context),
  }
}